import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Home2 from "./Home2";

import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Button from "react-bootstrap/Button";


function Home() {

  const { t } = useTranslation();

  return (
    <section>
      <Container fluid className="home-section home-page" id="home">
        <Container className="home-content">
          <Row className="home-hero" style={{ justifyContent: "center" }}>
            <Col md={10} lg={8} className="home-hero-col">
              <div className="policy-card home-hero-card">
                <div className="home-hero-card-body">
                  <h1 className="home-hero-title home-hero-title--brand">
                    <img
                      src={homeLogo}
                      alt={t("home.a11y.logoAlt")}
                      className="home-hero-inline-logo"
                    />
                    <span className="home-hero-brand-name">
                      Choicest Fruit<span className="small-r-symbol">®</span>
                    </span>
                  </h1>

                  <p className="home-hero-lead">
                    <Trans i18nKey="home.hero.lead">
                      Knowledge and Technology <strong className="main-name">Serving the Welfare of Humanity</strong>
                    </Trans>
                  </p>

                  <p className="home-approval-statement">
                    {t("homeV2.hero.approval")}
                  </p>

                  <div className="home-cta">
                    <Button as={Link} to="/courses" size="lg" className="custom-yellow-btn home-cta-btn home-hero-premium-btn">
                      {t("homeV2.hero.cta")}
                    </Button>
                  </div>

                  <p className="home-hero-eyebrow">{t("homeV2.hero.eyebrow")}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
